import React, { useState, useEffect } from 'react';
import api from '../../api';
import { FaBolt, FaSave, FaTrash, FaPlus, FaEdit } from 'react-icons/fa';
import styles from './Admin.module.css';

const AdminNetMetering = () => {
  const [activeTab, setActiveTab] = useState('settings'); // settings, steps, benefits
  const [data, setData] = useState({ steps: [], benefits: [], settings: {} });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ text: '', type: '' });

  // Forms
  const [stepForm, setStepForm] = useState({ id: 0, title: '', description: '', iconName: 'FaBolt', colorHex: '#2196F3' });
  const [benefitInput, setBenefitInput] = useState('');


  useEffect(() => { fetchData(); }, []);

  const fetchData = async () => {
    try {
    const res = await api.get('/NetMetering');
      setData(res.data);
    } catch (err) { console.error(err); }
  };

  // --- SETTINGS (Example & CTA) ---
  const handleSettingChange = (e) => {
    setData({ ...data, settings: { ...data.settings, [e.target.name]: e.target.value } });
  };

  const saveSettings = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
     await api.post('/NetMetering/update-settings', data.settings);
      setMessage({ text: "Settings Updated!", type: "success" });
    } catch (err) { setMessage({ text: "Error saving settings", type: "error" }); }
    finally { setLoading(false); }
  };

  // --- STEPS ---
  const saveStep = async (e) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem('token');
     await api.post('/NetMetering/save-step', stepForm);
      fetchData(); setStepForm({ id: 0, title: '', description: '', iconName: 'FaBolt', colorHex: '#2196F3' });
    } catch (err) { alert("Error saving step"); }
  };

  const deleteStep = async (id) => {
    if(!window.confirm("Delete Step?")) return;
    const token = localStorage.getItem('token');
    await api.delete(`/NetMetering/delete-step/${id}`);
    fetchData();
  };

  // --- BENEFITS ---
  const addBenefit = async () => {
    if(!benefitInput) return;
    try {
      const token = localStorage.getItem('token');
     await api.post('/NetMetering/save-benefit', { id: 0, benefitText: benefitInput });
      fetchData(); setBenefitInput('');
    } catch (err) { alert("Error adding benefit"); }
  };

  const deleteBenefit = async (id) => {
    const token = localStorage.getItem('token');
   await api.delete(`/NetMetering/delete-benefit/${id}`);;
    fetchData();
  };

  if (!data.settings) return <div style={{color:'white'}}>Loading...</div>;

  return (
    <div className={styles.formCard} style={{ maxWidth: '900px' }}>
      <h3 style={{ marginBottom: '1.5rem', color: '#4ade80' }}><FaBolt /> Net Metering Management</h3>

      <div style={{ display: 'flex', gap: '10px', marginBottom: '20px', borderBottom: '1px solid #444', paddingBottom: '10px' }}>
        {['settings', 'steps', 'benefits'].map(tab => (
          <button 
            key={tab} onClick={() => setActiveTab(tab)}
            style={{
              padding: '8px 15px', borderRadius: '5px', border: 'none', cursor: 'pointer', fontWeight: 'bold', textTransform: 'capitalize',
              background: activeTab === tab ? '#4ade80' : 'transparent', color: activeTab === tab ? '#000' : '#888'
            }}
          >
            {tab}
          </button>
        ))}
      </div>

      {message.text && <div style={{padding:'10px', marginBottom:'20px', background: message.type==='error'?'#ef444433':'#4ade8033', color: message.type==='error'?'#ef4444':'#4ade80', borderRadius:'5px'}}>{message.text}</div>}

      {/* TAB 1: SETTINGS (Example Calc) */}
      {activeTab === 'settings' && (
        <form onSubmit={saveSettings}>
          <h4 style={{color:'#ff9800', marginBottom:'15px'}}>Calculation Example Values</h4>
          <div style={{display:'grid', gridTemplateColumns:'1fr 1fr', gap:'15px'}}>
            <div className={styles.formGroup}><label>Solar Gen (+500)</label><input className={styles.formInput} name="ex_Gen" value={data.settings.ex_Gen} onChange={handleSettingChange} /></div>
            <div className={styles.formGroup}><label>Consumption (-200)</label><input className={styles.formInput} name="ex_Cons" value={data.settings.ex_Cons} onChange={handleSettingChange} /></div>
            <div className={styles.formGroup}><label>Export (300)</label><input className={styles.formInput} name="ex_Export" value={data.settings.ex_Export} onChange={handleSettingChange} /></div>
            <div className={styles.formGroup}><label>Import (-250)</label><input className={styles.formInput} name="ex_Import" value={data.settings.ex_Import} onChange={handleSettingChange} /></div>
            <div className={styles.formGroup}><label>Net Result (+50)</label><input className={styles.formInput} name="ex_Net" value={data.settings.ex_Net} onChange={handleSettingChange} /></div>
            <div className={styles.formGroup}><label>Note Text</label><input className={styles.formInput} name="ex_Note" value={data.settings.ex_Note} onChange={handleSettingChange} /></div>
          </div>
          
          <h4 style={{color:'#4ade80', margin:'20px 0 10px'}}>Bottom CTA Section</h4>
          <div className={styles.formGroup}><label>Title</label><input className={styles.formInput} name="ctA_Title" value={data.settings.ctA_Title} onChange={handleSettingChange} /></div>
          <div className={styles.formGroup}><label>Description</label><textarea className={styles.formInput} name="ctA_Desc" value={data.settings.ctA_Desc} onChange={handleSettingChange} rows="2" /></div>
          
          <button className={styles.primaryBtn} disabled={loading}>{loading ? 'Saving...' : <><FaSave /> Save Settings</>}</button>
        </form>
      )}

      {/* TAB 2: STEPS */}
      {activeTab === 'steps' && (
        <div>
          <form onSubmit={saveStep} style={{background:'#ffffff10', padding:'15px', borderRadius:'10px', marginBottom:'20px'}}>
            <div style={{display:'grid', gridTemplateColumns:'1fr 1fr', gap:'10px', marginBottom:'10px'}}>
              <input className={styles.formInput} placeholder="Title" value={stepForm.title} onChange={e=>setStepForm({...stepForm, title:e.target.value})} required />
              <div style={{display:'flex', gap:'5px'}}>
                <input className={styles.formInput} placeholder="Icon (FaBolt)" value={stepForm.iconName} onChange={e=>setStepForm({...stepForm, iconName:e.target.value})} />
                <input type="color" value={stepForm.colorHex} onChange={e=>setStepForm({...stepForm, colorHex:e.target.value})} style={{height:'42px', width:'50px', border:'none', background:'none'}} />
              </div>
            </div>
            <textarea className={styles.formInput} placeholder="Description" value={stepForm.description} onChange={e=>setStepForm({...stepForm, description:e.target.value})} rows="2" />
            <button className={styles.primaryBtn} style={{marginTop:'10px'}}><FaPlus /> {stepForm.id===0?'Add Step':'Update Step'}</button>
          </form>

          {data.steps.map(step => (
            <div key={step.id} style={{display:'flex', justifyContent:'space-between', alignItems:'center', background:'#ffffff05', padding:'10px', marginBottom:'5px', borderRadius:'5px', borderLeft:`4px solid ${step.colorHex}`}}>
              <div style={{color:'white'}}><strong>{step.title}</strong><br/><small style={{color:'#888'}}>{step.description}</small></div>
              <div>
                <button onClick={()=>setStepForm(step)} style={{color:'#4ade80', background:'none', border:'none', marginRight:'10px', cursor:'pointer'}}><FaEdit /></button>
                <button onClick={()=>deleteStep(step.id)} style={{color:'#ef4444', background:'none', border:'none', cursor:'pointer'}}><FaTrash /></button>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* TAB 3: BENEFITS */}
      {activeTab === 'benefits' && (
        <div>
          <div style={{display:'flex', gap:'10px', marginBottom:'20px'}}>
            <input className={styles.formInput} placeholder="Benefit Text" value={benefitInput} onChange={e=>setBenefitInput(e.target.value)} />
            <button className={styles.primaryBtn} onClick={addBenefit} style={{width:'100px'}}>Add</button>
          </div>
          {data.benefits.map(ben => (
            <div key={ben.id} style={{display:'flex', justifyContent:'space-between', background:'#ffffff05', padding:'10px', marginBottom:'5px', borderRadius:'5px'}}>
              <span style={{color:'white'}}>{ben.benefitText}</span>
              <button onClick={()=>deleteBenefit(ben.id)} style={{color:'#ef4444', background:'none', border:'none', cursor:'pointer'}}><FaTrash /></button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default AdminNetMetering;